import React from "react";
import { MessageProps, IntentionItem } from "./types";
import { sortIntentionsByDate, isMessageSharedWithUser } from "./utils";
import { useMessageContext } from "./MessageContext";
import MessageItem from "./MessageItem";

/**
 * Message component for displaying and managing intention/subliminal messages
 * Supports sharing, accepting/declining, and deletion functionality
 */
const Message: React.FC<MessageProps> = ({
  onClick,
  remove,
  subliminal,
  data,
  share,
  ...props
}) => {
  const { isMessageAccepted, declinedMessages } = useMessageContext();

  /**
   * Renders the list of message items
   */
  const renderMessageItems = () => {
    if (!data || !Array.isArray(data)) {
      return null;
    }

    const sortedIntentions = sortIntentionsByDate(data).filter(
      (intention) => !declinedMessages.has(intention.id)
    );

    return sortedIntentions.map((intention: IntentionItem, index: number) => {
      const isSharedWithMe = isMessageSharedWithUser(intention);
      const sharedId = intention.shared?.id;

      const approvalStatus = intention.shared?.approvalFlowStatus;
      const isAccepted =
        isMessageAccepted(intention.id) || approvalStatus === "APPROVED";

      intention.shared && console.log(intention.shared);
      
      !intention.shared && console.log(intention);

      let senderData: {
        name: string;
        sentAt: string | number;
        roleId: number | null;
      } | null = null;

      if (intention && intention.shared) {
        if (isSharedWithMe) {
          senderData = {
            name: intention.shared.owner.name,
            sentAt: intention.shared.createdAt,
            roleId: intention.shared.owner.roleId,
          };
        }
      }

      return (
        <MessageItem
          key={intention.id}
          intention={intention}
          index={index}
          isSharedWithMe={isSharedWithMe}
          isAccepted={isAccepted}
          onClick={onClick}
          onShare={share}
          remove={remove}
          subliminal={subliminal}
          sharedId={sharedId}
          approvalStatus={approvalStatus}
          senderData={senderData}
          createdAt={intention.createdAt}
        />
      );
    });
  };

  return <>{renderMessageItems()}</>;
};

export default Message;
